import React from 'react';

import {
  Grid,
  Button
} from '@mui/material';
import {
  fields,
  authService
} from 'modules';

import * as dataService from './dataService';



const ControlledTextField = fields.genTextFieldControllerComponent<dataService.IFormState>();



export const EditProfileSection: React.FC = () => {
  const [authLoading, setAuthLoading] = React.useState(false);
  const {
    form,
    loading: mutationLoading,
    mutations
  } = dataService.useEditProfileSection();
  const loading = mutationLoading || authLoading;



  async function processSubmit(formData: dataService.IFormState) {
    try {
      await mutations.saveAdminProfile(formData);
      setAuthLoading(true);
      await authService.updateEmail(formData.email);
    } catch (error) {
      alert(error);
    } finally {
      setAuthLoading(false);
    }
  }



  return (
    <form onSubmit={form.handleSubmit(processSubmit)}>
      <Grid container spacing={5}>
        <Grid
          container item
          spacing={5}>
          <Grid item xs={6}>
            <ControlledTextField
              fieldKey="firstName"
              label="First Name"
              formControl={form.control}
            />
          </Grid>

          <Grid item xs={6}>
            <ControlledTextField
              fieldKey="lastName"
              label="Last Name"
              formControl={form.control}
            />
          </Grid>

          <Grid item xs={6}>
            <ControlledTextField
              fieldKey="email"
              label="Email"
              formControl={form.control}
            />
          </Grid>
        </Grid>

        <Grid item xs>
          <Button
            type="submit"
            variant="contained"
            size="medium"
            disabled={loading}>
            Update Profile
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};
